import { render, staticRenderFns } from "./ProgramItemPoster.vue?vue&type=template&id=1b8a6522&scoped=true&"
import script from "./ProgramItemPoster.vue?vue&type=script&lang=js&"
export * from "./ProgramItemPoster.vue?vue&type=script&lang=js&"
import style0 from "./ProgramItemPoster.vue?vue&type=style&index=0&id=1b8a6522&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8a6522",
  null
  
)

export default component.exports